// extracted by mini-css-extract-plugin
export var container = "_fj-1";
export var editor = "_fj-2";
export var resizable = "_fj-3";
export var wrapper = "_fj-0";